<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		listItem: Snippet<[any, number]>;
		header: Snippet;
		list?: any[];
		error?: string;
		errorItem?: Snippet;
		dataTestId?: string;
		onClick?: (e: MouseEvent | KeyboardEvent) => void;
		onGlobalClick?: (e: MouseEvent | KeyboardEvent) => void;
	}

	const {
		listItem,
		header,
		list,
		error,
		errorItem,
		onClick,
		onGlobalClick,
		dataTestId,
	}: Props = $props();
</script>
<div
	class="w-full"
	role="button"
	tabindex="0"
	onclick={e => onGlobalClick?.(e)}
	onkeydown={e => e.key === 'Enter' && onGlobalClick?.(e)}
	data-testid={dataTestId}
>
	<div
		class="list-group-header relative px-2 cursor-pointer pb-3 grid grid-cols-[minmax(0,1fr)_36px]"
		onclick={e => onClick?.(e)}
		onkeydown={e => e.key === 'Enter' && onClick?.(e)}
		role="button"
		tabindex="0"
	>
		{@render header?.()}
	</div>
	<ul class="list-reset">
		{#if list && !error}
			{#each list as item, index (index)}
				<li>
					{@render listItem?.(item, index)}
				</li>
			{/each}
		{:else}
			<li class="py-2">
				{@render errorItem?.()}
			</li>
		{/if}
	</ul>
</div>

<style>

	.list-group-header {
		grid-template-areas:
				'header button'
				'badge button';
	}

</style>
